<template>
  <div v-if="innerNavData!=null" class="tEachLobbyTabParentDiv">
    <div :style="{
      display: 'flex',
      width: '100%',
      backgroundColor:HNewGameUIConfig.newGameUIType === 3 ?'#0000':'#f3f4f9',
    }">
      <div style="width: 90px;">
        <van-sticky offset-top="30px;">
          <div :style="{
            marginTop:index ===0 ? '20px':'10px',
            padding:'6px 0',
            display: 'flex',alignItems:'center',
            justifyContent:'center',
            borderBottomLeftRadius:HNewGameUIConfig.newGameUIType === 3 || HNewGameUIConfig.newGameUIType === 4 ?'30px':'0',
            borderTopLeftRadius:HNewGameUIConfig.newGameUIType === 3 || HNewGameUIConfig.newGameUIType === 4 ?'30px':'0',
            backgroundColor:activeIndex === index?hcf.getMainColor():'',
          }" v-for="(eachInner,index) in innerNavData" :key="eachInner['Name']">
            <div @click="changeLeftTab(index)" :style="hcf.getTextStyle({
        color:activeIndex === index?'white':'#666',addSize:1,fontWeight:activeIndex === index?'bold':''
      })">{{eachInner["Name"]}}</div>
          </div>
        </van-sticky>
      </div>
      <div style="width: calc(100% - 90px);">
        <EachLobbyRight :style="{width:rightDivWidth+'px'}" :innerNavId="curInnerNavId" :childNavId="innerNavData[activeIndex]['Id']"/>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {ref} from "vue";
  import EachLobbyRight from "@/components/pages/Lobby/EachLobbyRight.vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  const props = defineProps(["curInnerNavId","initChildNavId"]);
  const user = useUserStore();
  const http = useHHttp();
  const innerNavData = ref(null);
  let activeIndex = ref(0);
  const rightDivWidth = ref(0);
  function changeLeftTab(index){
    activeIndex.value = index;
  }

  onMounted(()=>{
    rightDivWidth.value = window.innerWidth - 90;
    useHComApi().getSecondGameData((resp)=>{
      innerNavData.value = resp["Data"]["CurNav"]["InnerChildNav"];
      if(props.initChildNavId){
        for(let i = 0;i<innerNavData.value.length;i++){
          if(props.initChildNavId === innerNavData.value[i]["Id"]){
            activeIndex.value = i;
            break;
          }
        }
      }
    }, {
      innerNavId: props.curInnerNavId, childNavId: 0
    });
  });

</script>


<style scoped>
  .tEachLobbyTabParentDiv {
    display: flex;
    flex-direction: row;
    height:100%;
  }

</style>
